import { useEffect, useState } from 'react'

type Countdown = {
  minutes: string
  seconds: string
  formatted: string
  isExpired: boolean
}

export function useCountdown(initialSeconds: number): Countdown {
  const [remaining, setRemaining] = useState<number>(initialSeconds)

  useEffect(() => {
    if (remaining <= 0) return
    const id = window.setInterval(() => {
      setRemaining((current) => (current <= 1 ? 0 : current - 1))
    }, 1000)
    return () => window.clearInterval(id)
  }, [remaining])

  const minutes = Math.floor(remaining / 60)
    .toString()
    .padStart(2, '0')
  const seconds = (remaining % 60).toString().padStart(2, '0')

  return {
    minutes,
    seconds,
    formatted: `${minutes}:${seconds}`,
    isExpired: remaining <= 0
  }
}
